import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from './api.js';

export interface Me {
  readonly customerId: string;
  readonly email: string;
  readonly displayName: string;
  readonly companyName?: string;
  readonly role: 'customer' | 'admin';
}

const ME_KEY = ['me'] as const;

export function useMe() {
  return useQuery<Me | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await api.get<Me>('/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000
  });
}

export function useRequestMagicLink() {
  return useMutation({
    mutationFn: (email: string) => api.post('/auth/login', { email })
  });
}

export function useVerifyToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => api.post('/auth/verify', { token }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ME_KEY })
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/auth/logout'),
    onSuccess: () => qc.setQueryData<Me | null>(ME_KEY, null)
  });
}
